var map = {
	"./work_1.png": "./src/img/works/inner/work_1.png",
	"./work_10.png": "./src/img/works/inner/work_10.png",
	"./work_11.png": "./src/img/works/inner/work_11.png",
	"./work_12.png": "./src/img/works/inner/work_12.png",
	"./work_2.png": "./src/img/works/inner/work_2.png",
	"./work_3.png": "./src/img/works/inner/work_3.png",
	"./work_4.png": "./src/img/works/inner/work_4.png",
	"./work_5.png": "./src/img/works/inner/work_5.png",
	"./work_6.png": "./src/img/works/inner/work_6.png",
	"./work_7.png": "./src/img/works/inner/work_7.png",
	"./work_8.png": "./src/img/works/inner/work_8.png",
	"./work_9.png": "./src/img/works/inner/work_9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/works/inner sync \\.(png%7Cjpe?g%7Csvg)$";